export function getAuthToken() {
    return localStorage.getItem("authToken");
}

export function getLoggedUser() {
    let loggedUser = localStorage.getItem("loggedUser");
    let json = JSON.parse(JSON.parse(loggedUser));
    return json;
}

export function getMembership() {
    let membership = localStorage.getItem("membership");
    let json = JSON.parse(JSON.parse(membership));
    return json;
}

export function getLicense() {
    let license = localStorage.getItem("license");
    let json = JSON.parse(JSON.parse(license));
    return json;
}

export function getInstitution() {
    let institution = localStorage.getItem("institution");
    let json = JSON.parse(JSON.parse(institution));
    return json;
}